import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase client config - safe to expose; security is via Firestore rules
// Env vars used when set (e.g. Netlify); fallbacks for when they're not
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyB3Zd9w0ctXD5dyOuWMisk3Yx-0ZDHEwFM",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "roster-app-bb0b1.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "roster-app-bb0b1",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "roster-app-bb0b1.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "722585089686",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:722585089686:web:aded098c18f037ff72b4b7",
};


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, googleProvider, signInWithPopup, signOut, db, storage };
